import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer id="footer" className="footer">
      <div className="wrap">
        <div className="gototop">
          <p>
            <a href="#wrap" rel="nofollow">Return to top of page</a>
          </p>
        </div>
        <div className="creds">
          <p>
            Copyright &copy; {new Date().getFullYear()} AEuromotive, Inc., All rights reserved.
            <br />
            Website maintained by{' '}
            <a href="http://www.koehlercybercafe.com/" target="_blank" rel="noopener noreferrer">
              Koehler Cyber Cafe, Inc.
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;






